import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-tap',
  templateUrl: './events-tap.component.html',
  styleUrls: ['./events-tap.component.scss'],
})
export class EventsTapComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/tap/1.jpg',
      thumbnail: 'assets/img/school/events/tap/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/tap/2.jpg',
      thumbnail: 'assets/img/school/events/tap/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/tap/3.jpg',
      thumbnail: 'assets/img/school/events/tap/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/tap/4.jpg',
      thumbnail: 'assets/img/school/events/tap/4.jpg',
      alt: 'Image 01',
    },
  ];
}
